import React, { ReactNode, useContext, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import {
	componentPagesMenu,
	dashboardPagesMenu,
	demoPagesMenu,
	getDashboardPagesMenu,
	// gettingStartedPagesMenu,
	pageLayoutTypesPagesMenu,
} from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import Hand from '../../../assets/img/hand.png';
import HandWebp from '../../../assets/img/hand.webp';
import Icon from '../../../components/icon/Icon';
import Button from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const [doc, setDoc] = useState(
		localStorage.getItem('facit_asideDocStatus') === 'true' || false,
	);

	const { t } = useTranslation(['translation', 'menu']);

	const { darkModeStatus } = useDarkMode();

	// Get user role and dynamic menu
	const userRole = localStorage.getItem('userRole');
	const dynamicDashboardMenu = getDashboardPagesMenu();

	// Check user roles
	const isContractor = userRole === 'Contractor';
	const isCityAdminJunagadh = userRole === 'City Admin Junagadh';
	const isCityAdminPonda = userRole === 'City Admin Ponda';
	const isFieldStaff = userRole === 'Field Person Ponda';

	// For Ponda and Field Staff: treat as restricted but with different menu structure
	const isRestrictedRole =
		isContractor || isCityAdminJunagadh || isCityAdminPonda || isFieldStaff;

	// Optional: Get a role-specific menu title
	const getMenuTitle = () => {
		if (isContractor) return 'Contractor Menu';
		if (isCityAdminJunagadh) return 'City Admin Menu - Junagadh';
		if (isCityAdminPonda) return 'City Admin Menu - Ponda';
		if (isFieldStaff) return 'Field Staff Menu';
		return 'Dashboard';
	};

	// Check if we should show dynamic menu
	const shouldShowDynamicMenu = () => {
		if (isRestrictedRole) {
			// For Ponda, Field Staff, Contractor & Junagadh: Show all dynamic menu items
			return Object.keys(dynamicDashboardMenu).length > 0;
		}
		return false;
	};

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				{!doc && (
					<>
						{/* For Restricted Roles (Contractor, City Admin Junagadh, City Admin Ponda & Field Staff): Show dynamic menu */}
						{shouldShowDynamicMenu() && (
							<>
								{/* Optional: Add a menu header/title */}
								{/* <div className="menu-title px-3 py-2 text-muted small">{getMenuTitle()}</div> */}
								<Navigation
									menu={dynamicDashboardMenu as any}
									id='aside-restricted-menu'
								/>
								<NavigationLine />
							</>
						)}

						{/* For Non-Restricted Roles: Show all regular menus */}
						{!isRestrictedRole && (
							<>
								<Navigation menu={dashboardPagesMenu} id='aside-dashboard' />
								<NavigationLine />
								<Navigation menu={demoPagesMenu} id='aside-demo-pages' />
								<NavigationLine />
							</>
						)}
					</>
				)}
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
